import { render, staticRenderFns } from "./refundsDetail.vue?vue&type=template&id=c02851da&"
import script from "./refundsDetail.vue?vue&type=script&lang=js&"
export * from "./refundsDetail.vue?vue&type=script&lang=js&"
import style0 from "./refundsDetail.vue?vue&type=style&index=0&id=c02851da&prod&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports